import { PairInfo } from 'utils/pair-info'

export enum Direction {
  Ascending = 'ascending',
  Descending = 'descending',
}

export enum SortBy {
  Vault = 'sortByVault',
  Tvl = 'sortByTvl',
  Apr = 'sortByApy',
  Deposited = 'sortByDeposited',
  Earned = 'sortByEarned',
}

export interface LpVaultListRow extends PairInfo<string> {
  [SortBy.Deposited]?: number
  [SortBy.Earned]?: number
  [SortBy.Apr]?: number
  [SortBy.Tvl]?: number
  tvl?: number
  deposited?: number
  apr?: string
  earned?: number
}

export enum TableValue {
  Deposit = 'deposited',
  Apr = 'apr',
  Tvl = 'tvl',
}
